export function isTourSchedulingEnabled() {
  const runtimeFlags = typeof window !== 'undefined' ? window.__SITESIFT_FEATURES__ : null;
  const enabledByBuild = process.env.REACT_APP_ENABLE_TOUR_SCHEDULING === 'true';

  if (!enabledByBuild) {
    return false;
  }

  if (runtimeFlags && Object.prototype.hasOwnProperty.call(runtimeFlags, 'tourScheduling')) {
    const runtimeValue = runtimeFlags.tourScheduling;
    if (runtimeValue === true) {
      return true;
    }
    if (runtimeValue === false || runtimeValue === 0 || runtimeValue == null) {
      return false;
    }
    if (typeof runtimeValue === 'string') {
      const normalizedValue = runtimeValue.trim().toLowerCase();
      return ['1', 'true', 'yes', 'on'].includes(normalizedValue);
    }
    return false;
  }

  return true;
}

const ENABLED_FEATURE_VALUES = new Set(['1', 'true', 'yes', 'on']);

export function isResultsBuildEnabled(buildValue) {
  return buildValue === 'true';
}

// Keep this expression compile-time literal so CRA removes the Results import
// from Base V1 production bundles. Non-canonical values intentionally fail closed.
export const RESULTS_BUILD_ENABLED = process.env.REACT_APP_ENABLE_RESULTS === 'true';

export function isResultsEnabled({
  buildEnabled = RESULTS_BUILD_ENABLED,
  runtimeFlags = typeof window !== 'undefined' ? window.__SITESIFT_FEATURES__ : null
} = {}) {
  if (!buildEnabled) return false;

  if (runtimeFlags && Object.prototype.hasOwnProperty.call(runtimeFlags, 'results')) {
    const runtimeValue = runtimeFlags.results;
    if (runtimeValue === true) return true;
    if (runtimeValue === false || runtimeValue === 0 || runtimeValue == null) return false;
    if (typeof runtimeValue === 'string') {
      return ENABLED_FEATURE_VALUES.has(runtimeValue.trim().toLowerCase());
    }
    return false;
  }

  return true;
}
